// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Detail_wrapper__Gk4P5","answer":"Detail_answer__1BMTS"};